var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,3)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 40 Q48 95 62 116 Q78 138 100 140 Q122 138 138 116 Q152 95 148 40Z",
    fill: "#00FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3,-3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 40 Q48 95 62 116 Q78 138 100 140 Q122 138 138 116 Q152 95 148 40Z",
    fill: "#FF00FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 40 Q48 95 62 116 Q78 138 100 140 Q122 138 138 116 Q152 95 148 40Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42 Q51 97 65 118 Q81 140 103 142 Q125 140 141 118 Q155 97 151 42Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55 Q28 55 26 78 Q24 100 52 96",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57 Q31 57 29 80 Q27 102 55 98",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148 58 Q170 60 172 82 Q174 104 148 100",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151 60 Q173 62 175 84 Q177 106 151 102",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 140,
    width: 18,
    height: 20,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 143,
    width: 18,
    height: 20,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 159,
    width: 72,
    height: 13,
    rx: 4,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 162,
    width: 72,
    height: 13,
    rx: 4,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 56,
    x2: 76,
    y2: 108,
    stroke: "#CC00CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 48,
    x2: 88,
    y2: 116,
    stroke: "#CC00CC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 58,
    x2: 79,
    y2: 110,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.f5b80dbc982348d3a04d0c96f64e692e.svg";
export { ForwardRef as ReactComponent };